import React from 'react';

import { Tr } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { isMobileView } from 'constants/isMobileView';

const NonHoverBodyTr = styled(Tr)`
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral.CFD7DF};
`;

const BodyTr = styled(Tr)`
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral.CFD7DF};
  & .showOnHover {
    visibility: hidden;
  }
  &:hover {
    background: ${(props) => props.theme.colors.neutral.F6FAFE};
    td:not(:first-child) {
      & > * {
        visibility: hidden;
      }
      & .showOnHover {
        visibility: visible;
      }
    }
    td:first-child {
      p {
        color: #1565bc;
      }
    }
  }
  & td {
    border: none;
  }
`;

// This the "variant" for new hover UX, where every cell apart from 1st has to be hidden on hover for react table

const TableHoverBodyRow = ({ children, ...props }) => {
  if (isMobileView()) {
    return (
      <NonHoverBodyTr bg="common.white" {...props}>
        {children}
      </NonHoverBodyTr>
    );
  }
  return (
    <BodyTr bg="common.white" {...props}>
      {children}
    </BodyTr>
  );
};

export { TableHoverBodyRow };
